import React from 'react';
import { Loader2, ShieldAlert } from 'lucide-react';
import useWorkflowFeatureAccess from '../hooks/useWorkflowFeatureAccess';

type WorkflowFeatureGuardProps = {
  children: React.ReactNode;
  organizationId?: string | null;
};

const WorkflowFeatureGuard: React.FC<WorkflowFeatureGuardProps> = ({ children, organizationId }) => {
  const { loading, hasAccess } = useWorkflowFeatureAccess(organizationId);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary-600" />
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white dark:bg-gray-800 shadow-lg rounded-lg p-6 text-center">
          <div className="flex justify-center mb-4">
            <ShieldAlert className="h-10 w-10 text-red-500" />
          </div>
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Zugriff verweigert</h2>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Ihre Organisation verfügt nicht über die erforderliche Workflow-Freigabe, um auf diese Funktion zuzugreifen.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default WorkflowFeatureGuard;
